export default {
    importEmployeeData: 'Import Employee Data',
    downloadErrorFile: 'You can export and edit. Please upload again when you edit complete.'
}
